import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { LoaderService } from '@teem/core/services/loader.service';
import { ProductService } from '@teem/services/product.service';
import { messages as i18n } from '@teem/core/constants/messages';

@Component({
	selector: 'app-import-product-modal',
	templateUrl: './import-product-modal.component.html',
	styleUrls: ['./import-product-modal.component.scss']

})

export class ImportProductModalComponent implements OnInit {
	@ViewChild('newProductForm') newProductForm: FormGroupDirective;
	productForm: FormGroup;
	submitted: boolean = false;
	uploadedFile: any;
	formData = new FormData();

	pondOptions = {
		multiple: false,
		allowReplace: false,
		allowRemove: true,
		allowImageResize: true,
		allowImagePreview: true,
		imageResizeMode: 'cover',
		acceptedFileTypes: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet",
		labelIdle: `<span class="icon-upload"></span>`
		// labelIdle: `<div class="upload-zone">
        //     <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        //         <path d="M16.3332 2.64787V7.46683C16.3332 8.12022 16.3332 8.44692 16.4603 8.69648C16.5722 8.91601 16.7507 9.09448 16.9702 9.20634C17.2197 9.3335 17.5464 9.3335 18.1998 9.3335H23.0188M23.3332 11.6531V20.0668C23.3332 22.027 23.3332 23.0071 22.9517 23.7558C22.6161 24.4144 22.0807 24.9498 21.4221 25.2854C20.6734 25.6668 19.6934 25.6668 17.7332 25.6668H10.2665C8.30632 25.6668 7.32623 25.6668 6.57754 25.2854C5.91897 24.9498 5.38354 24.4144 5.04798 23.7558C4.6665 23.0071 4.6665 22.027 4.6665 20.0668V7.9335C4.6665 5.97331 4.6665 4.99322 5.04798 4.24453C5.38354 3.58596 5.91897 3.05053 6.57754 2.71497C7.32623 2.3335 8.30632 2.3335 10.2665 2.3335H14.0136C14.8696 2.3335 15.2977 2.3335 15.7005 2.4302C16.0576 2.51594 16.399 2.65736 16.7122 2.84926C17.0654 3.0657 17.368 3.36837 17.9734 3.9737L21.693 7.69329C22.2983 8.29862 22.601 8.60129 22.8174 8.9545C23.0093 9.26765 23.1507 9.60906 23.2365 9.96618C23.3332 10.369 23.3332 10.797 23.3332 11.6531Z" stroke="#646464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        //     </svg>
        //     <p>Drag &amp; drop your files here</p>
        //     <p>or</p>
        //     <button class="browse-button btn btn-dark">Browse</button>
        // </div>`
	};

	constructor(
		private fb: FormBuilder,
		private productService: ProductService,
		private loaderService: LoaderService,
		public activeModal: NgbActiveModal,
		private el: ElementRef) {
	}

	ngOnInit(): void {
		this.productForm = this.fb.group({});
	}

	onFileChange(event) {
		if (event.target.files.length > 0) {
			this.uploadedFile = event.target.files[0];
		}
	}

	removeFile() {
		this.uploadedFile = null;
	}

	pondHandleInit() {
		// console.log('FilePond has initialised', this.myPond);
	}

	pondHandleAddFile(event: any) {
		if (this.formData.has('uploaded_file')) {
			this.formData.set('uploaded_file', event.file.file);
		} else {
			this.formData.append('uploaded_file', event.file.file);
		}
	}

	downloadTemplate() {
		window.location.href = '/products/download?format=template';
	}

	submit() {
		if (!this.formData.has('uploaded_file')) {
			Swal.fire(i18n.alert.error, i18n.error.record_not_found, 'error');
		} else if (this.productForm.valid) {
			this.loaderService.startLoading();

			let fd: any = this.productForm.value;
			if (this.formData.has('uploaded_file')) {
				fd.uploaded_file = this.formData.get('uploaded_file');
			}

			this.productService.importFile(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe((data: any) => {
				this.loaderService.stopLoading();

				this.productForm.reset();
				this.activeModal.close(data);

				Swal.fire(i18n.done, data.message, 'success');
				this.submitted = false;
			}, err => {
				this.loaderService.stopLoading();
				// Set server side error
				if (err.status === 422) {
					if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
						let validationErrors = err.error.errors;
						Object.keys(validationErrors).forEach((prop) => {
							this.productForm.get(prop)?.setErrors({
								serverError: validationErrors[prop]
							})
						})
					}
				}
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			});
		}
	}
}
